export default __webpack_public_path__ + "static/media/samman_logo.a0ecf2f6.png";